module.exports = __webpack_public_path__ + "img/aws-2.e3a2f02a.png";